export default __webpack_public_path__ + "static/media/fernando-bertorello-1.ae1d1dea.webp";